/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CreateWithEmailAddressContactRequest
 */
export interface CreateWithEmailAddressContactRequest {
  /**
   *
   * @type {string}
   * @memberof CreateWithEmailAddressContactRequest
   */
  emailAddress: string
}

export function CreateWithEmailAddressContactRequestFromJSON(json: any): CreateWithEmailAddressContactRequest {
  return CreateWithEmailAddressContactRequestFromJSONTyped(json, false)
}

export function CreateWithEmailAddressContactRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateWithEmailAddressContactRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    emailAddress: json['email_address']
  }
}

export function CreateWithEmailAddressContactRequestToJSON(value?: CreateWithEmailAddressContactRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    email_address: value.emailAddress
  }
}
